export const partnerMarketingAssetsFields = {
  id: 'id',
  s3Key: 's3_key',
  originalFilename: 'original_filename',
  displayName: 'display_name',
  folderPath: 'folder_path',
  fileType: 'file_type',
  fileSizeBytes: 'file_size_bytes',
  contentType: 'content_type',
  publicUrl: 'public_url',
  uploadedByUserId: 'uploaded_by_user_id',
  createdAt: 'created_at',
  updatedAt: 'updated_at',
  deletedAt: 'deleted_at',
  search: 'search', // Virtual field for search filter
};

export const PARTNER_MARKETING_ASSETS_RESOURCE_NAME = 'partner-marketing-assets';

export interface PartnerMarketingAsset {
  id: number;
  s3_key: string;
  original_filename: string;
  display_name: string | null;
  folder_path: string;
  file_type: string;
  file_size_bytes: number;
  content_type: string;
  public_url: string;
  uploaded_by_user_id: number;
  created_at: string;
  updated_at: string | null;
}

export interface PresignedUrlResponse {
  upload_url: string;
  s3_key: string;
  expires_in: number;
  public_url: string;
}
